import type { ApiRange, RawRange } from "./FiltersForStatus";

export const filterRanges: Record<string, RawRange> = {
    "all done": { from: 100, fromType: 'include', to: 100, toType: 'include' },
    "final stages": { from: 66, fromType: 'exclude', to: 100, toType: 'exclude' },
    "middle stages": { from: 33, fromType: 'exclude', to: 66, toType: 'include' },
    "early stages": { from: 0, fromType: 'exclude', to: 33, toType: 'include' },
    "not started": { from: 0, fromType: 'include', to: 0, toType: 'include' },
};

const canMerge = (a: RawRange, b: RawRange): boolean => {
    if (b.from < a.to) return true;

    if (b.from === a.to) {
        return a.toType === 'include' || b.fromType === 'include';
    }

    return false;
};

const mergeRanges = (ranges: RawRange[]): RawRange[] => {
    if (!ranges.length) return [];

   const sorted = [...ranges].sort((a, b) => a.from - b.from);
  const result: RawRange[] = [{ ...sorted[0] }];

  for (let i = 1; i < sorted.length; i++) {
    const last = result[result.length - 1];
    const current = sorted[i];

    if (canMerge(last, current)) {
      if (current.to > last.to) {
        last.to = current.to;
        last.toType = current.toType;
      } else if (current.to === last.to) {
        last.toType =
          last.toType === 'include' || current.toType === 'include'
            ? 'include'
            : 'exclude';
      }
    } else {
      result.push({ ...current });
    }
  }

  return result;
};

export const buildApiFrequency = (values?: string[]): ApiRange[] | undefined => {
    if (!values?.length) return undefined;

    const rawRanges = values.map((v) => filterRanges[v]);
    const merged = mergeRanges(rawRanges);
    
    return merged.map((r) => ({
        from: {
            value: r.from.toString(),
            type: r.fromType,
        },
        to: {
            value: r.to.toString(),
            type: r.toType,
        },
    }));
};